import { render, staticRenderFns } from "./QuickActionsSlide.vue?vue&type=template&id=cdaa20ca&scoped=true&"
import script from "./QuickActionsSlide.vue?vue&type=script&lang=js&"
export * from "./QuickActionsSlide.vue?vue&type=script&lang=js&"
import style0 from "./QuickActionsSlide.vue?vue&type=style&index=0&id=cdaa20ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdaa20ca",
  null
  
)

export default component.exports